export default __webpack_public_path__ + "static/media/window-no-clouds.b3787722.webp";